/* eslint-disable react-hooks/exhaustive-deps */
'use client'

import { FC, useEffect, useRef, useState } from 'react'
import { GoKebabHorizontal } from 'react-icons/go'
import { Tooltip } from 'react-tooltip'

import { GenericOption } from './components'
import { IBatchActionsSelectProps, Subcomponents } from './types'

const BatchActionsSelect: FC<IBatchActionsSelectProps> & Subcomponents = ({
  children,
  disabled,
}) => {
  const [isSelectOpen, setIsSelectOpen] = useState<boolean>(false)
  const refMenu = useRef<HTMLDivElement>(null)
  const refSelect = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    document.addEventListener('click', closeDropDown)

    return () => {
      window.removeEventListener('click', closeDropDown)
    }
  }, [isSelectOpen])

  const closeDropDown = (e: any) => {
    if (
      isSelectOpen &&
      !refMenu.current?.contains(e.target as Node) &&
      !refSelect.current?.contains(e.target as Node)
    ) {
      setIsSelectOpen(false)
    }
  }

  const handleDropDown = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target instanceof Element && e.target.tagName === 'P') {
      setIsSelectOpen(false)
    }
  }

  return (
    <div className="w-fit relative">
      <button
        data-tooltip-id="batch-actions-select-more-actions-1"
        className="flex justify-center items-center min-w-8 min-h-8 rounded-full transition-all duration-100 hover:bg-grayscale-100"
        onClick={() => setIsSelectOpen((prev) => !prev)}
        ref={refSelect}
        disabled={disabled}
      >
        <GoKebabHorizontal className="w-[13px] h-[13px] transtransform rotate-90" />
      </button>
      {isSelectOpen && (
        <div
          ref={refMenu}
          onClick={(e) => handleDropDown(e)}
          className="flex flex-col absolute z-[1] left-0 bottom-0 w-full min-w-max py-2 rounded-[8px] h-auto opacity-1 transition-all bg-white shadow-[0_2px_2px_0_rgba(0,0,0,0.25)] overflow-auto items-start"
        >
          {children}
        </div>
      )}

      <Tooltip
        id="batch-actions-select-more-actions-1"
        place="bottom"
        content="Mais ações"
      />
    </div>
  )
}

BatchActionsSelect.GenericOption = GenericOption

export default BatchActionsSelect
